import { Grid } from "@material-ui/core";
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { useStyles } from "./QueueStatsStyles";


function QueueStats(props) {
      const theme = useTheme();
    const classes = useStyles(theme);
    const { isExpanded = false, label = '' } = props;

    const handleClick = () => {
        if (props.onClickHandler) {
            props.onClickHandler(label);
        }
    }

    return (
        <Grid
            style={{flexGrow: "1"}}
            className={clsx(classes.queueStats, {
                [classes.queueStatsExpanded]: isExpanded,
            })}
            onClick={handleClick}
        >
            {
                props.showLabel &&
                <Grid item>
                    {label}
                </Grid>
            }

            <Grid item>
                <span>Not Ready: {props.counts.NotReady}</span>
                <br/>
                <span style={{color: props.counts.Ready > 0 ? 'green' : '#EF513F'}}>Ready: {props.counts.Ready}</span>
            </Grid>
        </Grid>
    )
}

export default QueueStats;